import cx from "classnames";
import { FaRegStar, FaStar } from "react-icons/fa";

import FillStarIcon from "assets/icons/FillStarIcon";
import OutlineStarIcon from "assets/icons/OutlineStarIcon";

export default function FavoriteStar({
  isFavorite,
  activeClassName,
}: {
  isFavorite?: boolean;
  activeClassName?: string;
}) {
  return isFavorite ? (
    <FillStarIcon className={cx("h-24 w-24 text-yellow-alpha-100", activeClassName)} />
  ) : (
    <OutlineStarIcon className="h-24 w-24 text-white-alpha-60" />
  );
}
